module.exports = __webpack_public_path__ + "39e398fa61ed99db501c080fb416fd65.png";